import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class UpdateLogItem {
    ID: number;
    UpdateAllowed: boolean;
    HardwareScore: number;
    License_ID?: number;
    LicenseKey: string;
    DateTimeCreated: Date;

    public static FixDate(item: UpdateLogItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class UpdateLogItemArray extends Array<UpdateLogItem>  {
    public LastSort = new SortItem;

    constructor(...items: UpdateLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdateLogItemArray.prototype);
    }


    public static FixDates(items: UpdateLogItemArray) {
        items.forEach(x => UpdateLogItem.FixDate(x));
    }

    public static SortByDate( sortThis: UpdateLogItemArray ): UpdateLogItemArray {
        sortThis.sort((a, b) => {
            if (a.ID < b.ID ) return 1;
            else if (a.ID > b.ID) return -1;
            else return 0;
        });

        return sortThis;
    }

}
